export default __webpack_public_path__ + "static/media/eye-on.b6212bea.svg";